import dayjs from 'dayjs';

import type { PublicHoliday } from '../../modules/public-holidays/types/PublicHoliday';

const resolveHolidayDayRange = (holiday: PublicHoliday) => {
  const start = dayjs(holiday?.startDate);
  if (!start.isValid()) {
    return null;
  }

  const startOfDay = start.startOf('day');
  const endCandidate = holiday?.endDate ? dayjs(holiday.endDate) : startOfDay;
  const endOfDay = endCandidate.isValid() ? endCandidate.startOf('day') : startOfDay;

  return { startOfDay, endOfDay };
};

export const buildBlockingPublicHolidayDateSet = (publicHolidays: PublicHoliday[] = []): Set<string> => {
  const set = new Set<string>();

  (publicHolidays || []).forEach((holiday) => {
    if (holiday?.halfDay === true) {
      return;
    }

    const range = resolveHolidayDayRange(holiday);
    if (!range) {
      return;
    }

    let cursor = range.startOfDay;
    while (cursor.valueOf() <= range.endOfDay.valueOf()) {
      set.add(cursor.format('YYYY-MM-DD'));
      cursor = cursor.add(1, 'day');
    }
  });

  return set;
};

export const buildVisiblePublicHolidayMap = (publicHolidays: PublicHoliday[] = []): Map<string, PublicHoliday[]> => {
  const map = new Map<string, PublicHoliday[]>();

  (publicHolidays || []).forEach((holiday) => {
    const range = resolveHolidayDayRange(holiday);
    if (!range) {
      return;
    }

    let cursor = range.startOfDay;
    while (cursor.valueOf() <= range.endOfDay.valueOf()) {
      const dayKey = cursor.format('YYYY-MM-DD');
      const existing = map.get(dayKey) || [];
      existing.push(holiday);
      map.set(dayKey, existing);
      cursor = cursor.add(1, 'day');
    }
  });

  return map;
};
